import { IFundData } from "../../../../services/PortfolioModelWalletService";
import { IPortfolioModelTable } from "../Interfaces/SummaryPortfolioInterfaces";

export const convertPortfolioDataToFundData = (portfolioData: IPortfolioModelTable[], savingPlanId: number): IFundData[] =>
{
    return portfolioData.map((item: IPortfolioModelTable) =>
    {
        return{
            fund:
            {
                name: item.nameFund,
                isin: item.isin,
                finametrixId: '', // No disponible en los datos actuales
                allFundsId: 0 // No disponible en los datos actuales
            },
            savingPlanId: savingPlanId,
            modelPercentage: item.portfolioPercentage,
            readOnly: false // Por defecto no es de solo lectura
        };
    });
};